<script>
export default {
  inheritAttrs: false,
  model: {
    event: 'update',
  },
  props: {
    label: { type: String, default: null },
    rules: { type: String, default: '' },
    items: { type: Array, default: () => [] },
  },
}
</script>

<template>
  <BaseValidationProvider
    v-slot="{ errors }"
    :rules="rules"
    :label="label"
    :label-for="$attrs.id"
  >
    <div class="relative">
      <select
        v-bind="$attrs"
        :class="['input', errors.length ? 'input-error' : '']"
        v-on="$listeners"
        @input="$emit('update', $event.target.value)"
      >
        <option value=""></option>
        <option v-for="item in items" :key="item.value" :value="item.value">
          {{ item.text }}
        </option>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2"
      >
        <BaseIcon name="chevron-down" />
      </div>
    </div>
  </BaseValidationProvider>
</template>
